App.controller('ZochWorkersListCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaWorkersService', '$stateParams', '$timeout', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaWorkersService, $stateParams, $timeout) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_workers';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Lista kont';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    var page = 0;
    $scope.current = page;
    $scope.pageSize = 10;
    $scope.searchString = '';

    loadWorkers(page);

    function loadWorkers(page) {
    	var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize,
            searchString: $scope.searchString
        }

	    zochaWorkersService.dataList(criteria).then(function (data) {
	        if (data.status === 200) {
	            $scope.workers = data.data.data;
	            $scope.numberOfPages = data.data.pages;
	            // $scope.buildScroll();
	            console.log($scope.workers);
	        }
	    });
	}

	$scope.search = function () {
        loadWorkers(0);
    };

    $scope.pageChanged = function (page) {
        loadWorkers(page);
        $scope.current = page;
    };

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {
            
        }, function() {
            
        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }

    $scope.buildScroll = function() {
        $timeout(function() {
            scrollbarHorizontalMenu('.workers .scroll');
        }, 1);
    }

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis:"x",
            theme:"dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced:{autoExpandHorizontalScroll:true},
            callbacks:{
                onInit: function(){
                    
                },
                onScroll: function(){
                    
                }
            }
        });
    }
}]);